// extracted by mini-css-extract-plugin
export var button = "_7g-0";
export var icon = "_7g-1";